import {SearchDto} from "../../component/payment/dto/Search.dto";

export const GET_PAYMENTS = (searchDto: SearchDto): string => `
    query {
        getPayments(statuses: [${searchDto.statuses}], type: ${searchDto.type}, keyword: "${searchDto.keyword}", startDate: "${searchDto.startDate}", endDate: "${searchDto.endDate}", page: ${searchDto.page}) {
            items {
                seq
                paymentsNumber
                price
                userName
                email
                status
                paidAt
                content
                isLicense
            }
            currentPage
            totalPage
            totalItems
        }
    }
`;

export const GET_PAYMENT = (seq: number): string => `
    query {
        getPayment(seq: ${seq}) {
            licenseType
            lectureName
            thumbnailUrl
            price
            bank
            cardNumber
            accountNumber
            status
            paidAt
            refundPrice
            reason
            refundAt
        }
    }
`;